import t from "react";
import r from "classnames";
import v from "lodash";
import { useId as S } from "react-id-generator";
import { u as f } from "./ThemeProvider--i7ESlT5.es.js";
import { I as b } from "./Icon-BuIPTPJn.es.js";
import { T as l } from "./index-Dd-4N6BE.es.js";
import { n as g } from "./Normalize.module-BSsVv-vB.es.js";
import { N as k } from "./NoClickOutline-CllwvnB9.es.js";
import { u as x } from "./DarkModeProvider-xoZXm3ct.es.js";
import './Switch.css';const y = `<svg viewBox="0 0 10 9" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M9.03275 1.22493C8.66347 0.856012 8.06514 0.856012 7.69586 1.22493L3.08386 5.83693L1.58697 4.34004C1.21897 3.98624 0.635512 3.99197 0.274539 4.35295C-0.0864341 4.71392 -0.0921697 5.29738 0.261637 5.66538L2.38208 7.78582C2.79156 8.14081 3.39971 8.14081 3.80919 7.78582L9.03275 2.56227C9.21016 2.38496 9.30984 2.14442 9.30984 1.8936C9.30984 1.64278 9.21016 1.40223 9.03275 1.22493Z" fill="#2B2B2B"/>
</svg>`, N = "Switch-default-module__container___luCSb", $ = "Switch-default-module__disabled___pJgpD", C = "Switch-default-module__button___gFxFk", L = "Switch-default-module__withLabel___yRVNj", B = "Switch-default-module__dot_active___tNPdO", E = "Switch-default-module__dot_inactive___Q2yo8", z = "Switch-default-module__wrapper___zKl-X", I = "Switch-default-module__text_active___4ynTv", M = "Switch-default-module__text_inactive___mkmkX", T = "Switch-default-module__dark___-Bu3F", F = "Switch-default-module__gray___JNtB6", V = "Switch-default-module__blue___HTZGn", O = "Switch-default-module__green___qzn-z", Q = "Switch-default-module__purple___-bfyo", R = "Switch-default-module__lavender___G0Kkz", j = "Switch-default-module__red___bE0Xv", G = {
  container: N,
  disabled: $,
  button: C,
  withLabel: L,
  dot_active: B,
  dot_inactive: E,
  switch: "Switch-default-module__switch___INU-V",
  wrapper: z,
  text_active: I,
  text_inactive: M,
  dark: T,
  gray: F,
  blue: V,
  green: O,
  purple: Q,
  lavender: R,
  red: j
}, H = "Switch-compere-module__container___2VgEc", X = "Switch-compere-module__disabled___njyHM", Z = "Switch-compere-module__button___sfY1T", D = "Switch-compere-module__withLabel___Cffox", J = "Switch-compere-module__dot_active___-MnVj", K = "Switch-compere-module__dot_inactive___4n0Ub", U = "Switch-compere-module__wrapper___3x8GF", Y = "Switch-compere-module__text_active___Qtx7R", q = "Switch-compere-module__text_inactive___4mRSO", P = "Switch-compere-module__dark___day-o", W = "Switch-compere-module__gray___NSanQ", A = "Switch-compere-module__blue___kpSpi", ee = "Switch-compere-module__green___rZzsQ", te = "Switch-compere-module__pink___OWuzi", _e = "Switch-compere-module__purple___7VYpi", oe = {
  container: H,
  disabled: X,
  button: Z,
  withLabel: D,
  dot_active: J,
  dot_inactive: K,
  switch: "Switch-compere-module__switch___9B215",
  wrapper: U,
  text_active: Y,
  text_inactive: q,
  dark: P,
  gray: W,
  blue: A,
  green: ee,
  pink: te,
  purple: _e
}, d = {
  default: G,
  compere: oe
}, pe = ({
  onSwitch: m,
  text: i,
  label: o,
  labelProps: s = {},
  active: _ = !1,
  color: u = "gray",
  disabled: c = !1,
  id: p = void 0
}) => {
  const a = x(), w = f(), e = v.get(d, w, d.default), [h] = S(1, "switch-"), n = p || h;
  return /* @__PURE__ */ t.createElement(
    "div",
    {
      className: r(e.container, {
        [e.disabled]: c,
        [e.dark]: a
      })
    },
    /* @__PURE__ */ t.createElement(
      k.Button,
      {
        id: n,
        role: "switch",
        "aria-checked": _,
        className: r(
          g.normalize,
          e.button,
          e[u],
          o && e.withLabel,
          a && e.dark
        ),
        disabled: c,
        onClick: () => {
          c || m(!_);
        }
      },
      o && /* @__PURE__ */ t.createElement(
        l.Body3,
        {
          ...s,
          tagName: "label",
          htmlFor: n,
          responsive: !0
        },
        o
      ),
      /* @__PURE__ */ t.createElement("div", { className: e.wrapper }, /* @__PURE__ */ t.createElement("div", { className: e.switch }, /* @__PURE__ */ t.createElement("div", { className: _ ? e.dot_active : e.dot_inactive }, _ && /* @__PURE__ */ t.createElement(b, { svg: y, size: "0.625rem", ariaHidden: !0 }))), /* @__PURE__ */ t.createElement(
        l.Body,
        {
          tagName: "span",
          responsive: !0,
          className: _ ? e.text_active : e.text_inactive
        },
        _ ? i.active : i.inactive
      ))
    )
  );
};
export {
  pe as S
};
